import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { MultiLingualService } from '@fkhplus/common/src/services/locale/MultiLingualService'
import NetworkStatus from "@fkhplus/common/src/services/network/NetworkStatus";
import PlayGround from "@fkhplus/common/src/components/templates/PlayGround";
import RootTheme from "@fkhplus/common/src/components/templates/RootTheme";
import StateProvider from "@fkhplus/common/src/components/templates/StateProvider";


function App() {
  return (
    <StateProvider>
      <I18nextProvider i18n={MultiLingualService.instance}>
        <RootTheme>
          <PlayGround />
          <NetworkStatus />
        </RootTheme>
      </I18nextProvider>
    </StateProvider>
  )
}

export default App;